import { render, staticRenderFns } from "./AppToolBar.vue?vue&type=template&id=2478a641&scoped=true&"
import script from "./AppToolBar.vue?vue&type=script&lang=js&"
export * from "./AppToolBar.vue?vue&type=script&lang=js&"
import style0 from "./AppToolBar.vue?vue&type=style&index=0&id=2478a641&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478a641",
  null
  
)

export default component.exports